import { useEffect, useMemo, useRef, useState } from "react";
import { showErrorNotification, showSuccessNotification } from "../../../components/admin/common/NotiService";
import OZDataGrid from "../../../components/admin/common/OZDataGrid/OZDataGrid";
import { Button, Menu, MenuItem, Stack, Typography, Tooltip } from "@mui/material";
import AddBoxOutlinedIcon from '@mui/icons-material/AddBoxOutlined';
import { deleteClusterAccountByName, getClusterMDLList } from "../../../services/api-service";
import OZGridToolbar from "../../../components/admin/common/OZDataGrid/OZGridToolbar";
import DeleteDialog from "../../../components/admin/common/CustomDeleteDialog";
import ClusterAccountForm from "./ClusterAccountForm";
import LoadingScreen from "../../../components/admin/common/OZLoadingScreen/OZLoadingScreen";
import { writeAccess } from "../../../services/page-service";

export default function ClusterAccounts() {

    const [clusterAccountgridRef, setClusterAccountGridRef] = useState(null);
    const [clusterAccountrowData, setClusterAccountRowData] = useState(null);
    const [openDrawer, setDrawerState] = useState(false);
    const [openDailogState, setDailogState] = useState(false);
    const [showClusterAccountAddForm, setClusterAccountAddForm] = useState({ isNew: false, show: false })
    const [loading, setLoading] = useState(false);

    const [clusterAccountData, setClusterAccountData] = useState([]);
    useEffect(() => {
        getClusterMDLListFunction();
        localStorage.removeItem("clusterAccountForm");
    }, [])

    const handleCloseForm = () => {
        setClusterAccountAddForm(false);
        setClusterAccountAddForm({ isNew: false, show: false });
    }

    async function getClusterMDLListFunction() {
        setLoading(true);
        try {
            getClusterMDLList().then((resp) => {
                if (resp.Status === "Success" && resp.Data && resp.Data.length > 0) {
                    
                                        
                      const rowData = resp.Data.map((item) => ({
                        name: item,
                    }));

                    setClusterAccountData(rowData);
                } else {
                    setClusterAccountData([])
                }
                setLoading(false);
            }).catch((e) => {
                setLoading(false);
                setClusterAccountData([])
            })
        } catch (e) {
            setLoading(false);
            showErrorNotification("Error in the ClusterAccountList");
        }
    }



    async function deleteClusterAccount(name) {
        setLoading(true);
        setDailogState(false);
        setDrawerState(true);
        setClusterAccountAddForm({ isNew: false, show: false });
        try {
            const response = await deleteClusterAccountByName(name);
            if (response.Status === "Success") {
                showSuccessNotification(response.Message);
                getClusterMDLListFunction();
            } else {
                setLoading(false);
                showErrorNotification(JSON.stringify(response.Message));
            }
        }
        catch (e) {
            setLoading(false);
            showErrorNotification(JSON.stringify(e));
        }
    }

    const DateRenderer = (props) => {
        const date = new Date(props.data.createdDate);
        const options = { day: 'numeric', month: 'short', year: 'numeric', hour: 'numeric', minute: 'numeric', second: 'numeric' };

        return (
            <label>{date.toLocaleString("en-GB", options) || '-'}</label>
        );
    };
    const GetNameRenderer = (props) => {
        return (
            // <Tooltip title={props?.value ? props?.value : ""}>
            <span style={{ color: '#3D8BF8', textOverflow: "ellipsis", whiteSpace: "nowrap", overflow: "hidden" }}>{props.value}</span>
            // </Tooltip>
        )
    }

    const MouseEnterWidget = (props) => {
  const [anchorEl, setAnchorEl] = useState(null);
  const [deleteMode, setDeleteMode] = useState(false);
  const iconRef = useRef(null);

  const handleOpen = () => {
    setAnchorEl(iconRef.current);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const onClickDelete = () => {
    setAnchorEl(null);
    setDeleteMode(true);
  };

  const onConfirmDelete = () => {
    deleteClusterAccount(props.data.name);
    setDeleteMode(false);
  };

  return (
    <div
      style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        width: "100%"
      }}
    >
      {/* Name */}
      <span
        style={{
          color: "#3D8BF8",
          whiteSpace: "nowrap",
          overflow: "hidden",
          textOverflow: "ellipsis"
        }}
      >
        {props.value}
      </span>

      {/* More Vert */}
      {writeAccess() && (
        <>
          <img
            ref={iconRef}
            src={`${process.env.PUBLIC_URL}/icons/more_vert.svg`}
            alt="more"
            style={{ cursor: "pointer" }}
            onClick={handleOpen}
          />

          <Menu
            anchorEl={anchorEl}
            open={Boolean(anchorEl)}
            onClose={handleClose}
          >
            <MenuItem onClick={onClickDelete}>Delete</MenuItem>
          </Menu>
        </>
      )}

      {deleteMode && (
        <DeleteDialog
          title="Delete Cluster Account"
          content={`This will delete (${props.data.name}) from Cluster Accounts.`}
          open={true}
          onClose={() => setDeleteMode(false)}
          deleteFunction={onConfirmDelete}
        />
      )}
    </div>
  );
};

    
        async function onClickRow(rowItem) {
        setClusterAccountRowData(null);
        setLoading(true);
        setDailogState(false);
        setDrawerState(true);
        setClusterAccountAddForm({ isNew: false, show: true });
        try {
//            const response = await getFeatureById(rowItem.data.id);
//            if (response.Status === "Success" && response.Data) {
//                setFeatureRowData(response.Data);
//            } else {
                setClusterAccountRowData(null);
//            }
            setLoading(false);
        }
        catch (e) {
            setLoading(false);
            setClusterAccountRowData(null);
            showErrorNotification(JSON.stringify(e));
        }
    }


    const widgetcolumnDefs = ([
        { headerName: 'Name', field: 'name', cellRenderer: MouseEnterWidget,flex: 1 },
    ])

    const showSkillForm = () => {
        setClusterAccountAddForm({ isNew: true, show: true });
    };

    let buttonStyle = useMemo(
        () => ({
            borderRadius: "8px",
            height: "30px",
            fontSize: "11px",
            fontWeight: 400,
            width: '8rem',

        }),
        []
    );

    return (
        <div className="oz-administration-container">
            <Typography
                sx={{
                    fontweight: '400',
                    fontSize: '12px',
                    marginBottom: "5px"
                }}
                flexGrow={1}
                alignSelf="center"
            >
                Administration
            </Typography>

            <Stack direction="row" sx={{ marginBottom: 2, paddingLeft: '3px', }}>
                <Typography sx={{
                    fontStyle: 'normal',
                    fontWeight: 600,
                    fontSize: '24px',
                    lineHeight: '28px'
                }} flexGrow={1} alignSelf='center'>Cluster Accounts</Typography>
                {
                    writeAccess() && <Button
                        sx={buttonStyle}
                        variant="contained"
                        startIcon={<AddBoxOutlinedIcon />}
                        onClick={showSkillForm}
                    >
                        Add Account
                    </Button>
                }
            </Stack>

            <OZGridToolbar title="Cluster Account List"
                searchPlaceholder='Widget'
                rowCount={clusterAccountData.length}
                dataGridRef={clusterAccountgridRef}
                hideDownload={true}
            />
            {loading ?
                (
                    <div style={{ position: 'fixed', top: '0', left: '0', width: '100%', height: '100%', backgroundColor: '0,0,0,0.5', display: 'flex', justifyContent: 'center', alignItems: 'center', zIndex: 1000 }} >
                        <LoadingScreen />
                    </div>
                ) :
                <>
                    <OZDataGrid
                        columns={widgetcolumnDefs}
                        data={clusterAccountData}
                        setGridRef={setClusterAccountGridRef}
                        height="23.5rem"
                        rowClickCallback={writeAccess() ? onClickRow : null}
                    />
                </>
            }

            {showClusterAccountAddForm.show && showClusterAccountAddForm.isNew && (
                <ClusterAccountForm
                    Report={getClusterMDLListFunction}
                    delFunction={deleteClusterAccount}
                    onClose={handleCloseForm}
                    popClose={openDailogState}
                    drawerClose={openDrawer}
                />
            )}
            {loading ?
                (
                    <div style={{ position: 'fixed', top: '0', left: '0', width: '100%', height: '100%', backgroundColor: '0,0,0,0.5', display: 'flex', justifyContent: 'center', alignItems: 'center', zIndex: 1000 }} >
                        <LoadingScreen />
                    </div>
                ) :
                <>
                    {showClusterAccountAddForm.show && !showClusterAccountAddForm.isNew && (
                        <ClusterAccountForm
                            Report={getClusterMDLListFunction}
                            delFunction={deleteClusterAccount}
                            onClose={handleCloseForm}
                            data={clusterAccountrowData || []}
                            popClose={openDailogState}
                            drawerClose={openDrawer}
                        />
                    )}
                </>
            }
        </div>)
}